import { put } from "redux-saga/effects";
import { AxiosError } from "axios";

// Response / Request

// Redux
import { saveVisualIdentity } from "./index";

// Api's - Adicione sua API quando estiver disponível
// import { visualIdentityApi } from '../../api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getVisualIdentitySaga() {
	try {
		// Descomente quando a API estiver disponível
		// const response: AxiosResponse<Result<VisualIdentityResponse>> = yield call(
		//   visualIdentityApi.getVisualIdentity
		// );

		// if (response.data.result) {
		//   yield put(
		//     saveVisualIdentity(
		//       response.data.result.colors,
		//       response.data.result.logoUrl,
		//       false,
		//       null
		//     )
		//   );
		// }

		// Mock temporário - remova quando a API estiver disponível
		yield put(saveVisualIdentity(null, undefined, false, null));
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveVisualIdentity(null, undefined, true, resultError.messagesDataError));
		}
	}
}
